import { Flex, Text } from '@approvalmax/ui/src/components';
import { ui } from 'modules/common';
import { domain } from 'modules/data';
import { FC, memo, useEffect } from 'react';
import { useSplitViewContent } from 'shared/hooks/useSplitViewContent';
import { attachmentModes, ContentSplitViewMode } from 'shared/states';

import { SplitViewRequestCardWrapper } from '../../../../containers/SplitViewRequestCardWrapper/SplitViewRequestCardWrapper';
import AuditReportStatusIndicator from './components/AuditReportStatusIndicator/AuditReportStatusIndicator';
import { messages } from './LeftSplitViewItemContent.messages';
import { LeftSplitViewItemContentProps } from './LeftSplitViewItemContent.types';

export const LeftSplitViewItemContent: FC<LeftSplitViewItemContentProps> = memo((props) => {
    const {
        activeAttachment,
        auditReportStatus,
        goToNextDocument,
        goToPrevDocument,
        splitViewFirstItemTitle,
        setSplitViewFirstItemTitle,
    } = props;

    const { contentSplitViewMode } = useSplitViewContent();

    useEffect(() => {
        if (!setSplitViewFirstItemTitle) {
            return;
        }

        if (activeAttachment && splitViewFirstItemTitle !== activeAttachment.name) {
            setSplitViewFirstItemTitle(activeAttachment.name);
        }

        if (!activeAttachment && attachmentModes.includes(contentSplitViewMode) && splitViewFirstItemTitle !== '') {
            setSplitViewFirstItemTitle('');
        }
    }, [activeAttachment, splitViewFirstItemTitle, contentSplitViewMode, setSplitViewFirstItemTitle]);

    if (
        [ContentSplitViewMode.BillLinkedToBatchPayment, ContentSplitViewMode.NetSuiteBillLinkedToBillPayment].includes(
            contentSplitViewMode
        )
    ) {
        return <SplitViewRequestCardWrapper setContainerTitle={setSplitViewFirstItemTitle} />;
    }

    if (attachmentModes.includes(contentSplitViewMode)) {
        if (activeAttachment) {
            return (
                <Flex direction='column' spacing='0' height='100%' wrap={false}>
                    <Flex grow={1}>
                        <ui.DocumentPreviewPanel
                            document={activeAttachment}
                            onRequestBack={goToPrevDocument}
                            onRequestNext={goToNextDocument}
                        />
                    </Flex>
                </Flex>
            );
        } else {
            return (
                <Flex justifyContent='center' alignItems='center' height='100%'>
                    <Text font='body' fontSize='large'>
                        {messages.noAttachments}
                    </Text>
                </Flex>
            );
        }
    }

    if (contentSplitViewMode === ContentSplitViewMode.AuditReport) {
        if (auditReportStatus === domain.RequestAuditReportStatus.Ready && activeAttachment) {
            return (
                <ui.DocumentPreviewPanel
                    document={activeAttachment}
                    onRequestBack={goToPrevDocument}
                    onRequestNext={goToNextDocument}
                />
            );
        }

        return <AuditReportStatusIndicator auditReportStatus={auditReportStatus} />;
    }

    return null;
});

LeftSplitViewItemContent.displayName = 'LeftSplitViewItemContent';
